<div class="d-flex flex-row" style="border-bottom: 1px solid rgba(0, 0, 0, 0.125)">
  <!-- Cluster features checkbox  -->
  <div *ngIf="isVectorLayer()" class="form-check flex-fill"><!-- TODO: Remove function call from template -->
    <input name="layer-cluster" class="form-check-input" type="checkbox" [(ngModel)]="cluster" />
    <label class="form-check-label">{{
      "LAYERMANAGER.layerEditor.cluster" | translateHs
      }}</label>
  </div>
  <div class="form-group flex-fill" *ngIf="cluster">
    <label>{{ "COMMON.distance" | translateHs }}</label>
    <input name="layer-cluster-distance" type="range" min="0" max="100" step="1" [(ngModel)]="distance.value"
      (change)="changeDistance()" style="width: 100%; height: 21px" />
  </div>
</div>